<template>
    <div v-if="active"
         class="modal filter-modal is-active">
        <div class="modal-background" />
        <aside class="modal-card is-flex"
               qa="personalize-modal">
      <span v-if="!isSigningUp && !isCreate"
            class="close cursor-pointer" @click="close">
          <i class="fa-regular fa-times"></i>
      </span>
            <span>
        <header class="modal-header">
          <h2 class="modal-header-title">
              {{ this.$isIsef ? $t('filterModal.IsefTitle2023') : $t('filterModal.filter') }}
          </h2>
        </header>
        <section class="modal-content">
        <!-- Categories -->
        <accordion v-if="selectedCategoryID === 0 || selectedCategoryID === undefined"
                   :is-selected="() => selectedAccordionIdx(0)"
                   :is-open="0 === accordionIndex">
            <template #title>
                <span>Categories (Select All That Apply) <span class="selected-count">{{ selectedCategories.length }}</span></span>
            </template>
            <template #content>
                <div v-for="category in categoriesList"
                     :key="category.value"
                     class="modal-content-sorting-item">
                    <input name="category"
                           type="checkbox"
                           v-model="selectedCategories"
                           :value="category.id">
                    <span class="modal-content-sorting-title">
                      {{ category.name }}
                    </span>
                </div>
            </template>
        </accordion>
        <accordion  v-for="(group,index) in filter.filterGroups.filter((r) => isAwardRoute ? r.name !== 'awards' : r)"
                    :key="group.name"
                    :is-overflow="group.name === 'countries'"
                    :is-selected="() => selectedAccordionIdx(index + 1)"
                    :is-open="(index + 1) === accordionIndex">
          <template #title>
              {{ $t('filterModal.' + group.name) }}
              <span v-if="group.name === 'sorting'">(Select One) <span class="selected-count">{{ sort !== '' ? 1 : 0}}</span></span>
              <span v-else>(Select All That Apply)
                <span class="selected-count" v-if="group.name === 'countries'">{{ countriesSelected.length }}</span>
                <span class="selected-count" v-if="group.name === 'awards'">{{ selectedAwards.length }}</span>
              </span>
          </template>
          <template #content>
            <div v-if="group.name === 'sorting'"
                 class="modal-content-sorting">
                <div v-for="tag in group.tags"
                     :key="tag.value"
                     class="modal-content-sorting-item">
                    <input name="sorting_filter"
                           type="radio"
                           v-model="sort"
                           @click="selectSortingTag(tag)"
                           :value="tag.value">
                    <span class="modal-content-sorting-title">
                      {{ tag.label }}
                    </span>
                </div>
            </div>
            <div v-if="group.name === 'countries'"
                 class="is-flex modal-content-countries">
                <v-select placeholder="Select countries"
                          multiple
                          :options="countries"
                          label="name"
                          :reduce="(option) => option.id"
                          class="modal-content-countries-select"
                          v-model="countriesSelected">
                </v-select>
            </div>
            <div v-if="group.name === 'awards' && !isAwardRoute"
                 class="modal-content-sorting">
                <div v-for="award in awards"
                     :key="award.id"
                     class="modal-content-sorting-item">
                  <input name="award_filter"
                         type="checkbox"
                         v-model="selectedAwards"
                         :value="award.id">
                  <span class="modal-content-sorting-title">
                    {{ award.name }}
                  </span>
                </div>
            </div>
          </template>
        </accordion>
      </section>
      </span>
      <footer class="modal-footer">
          <button class="btn btn-secondary"
                  @click="clearAllFilters">
            {{ this.$isIsef ? $t('filterModal.reset') : $t('filterModal.clear') }}
          </button>
          <div v-if="isLoggedIn && !this.$isIsef" class="is-flex is-pulled-left">
              <input type="checkbox" class="remember" v-model="rememberTags">{{ $t('filterModal.rememberSetting') }}
          </div>
          <button type="submit"
                  class="btn btn-primary"
                  @click="setTagFilter">
            {{ this.$isIsef ? $t('filterModal.apply') : $t('category.apply') }}
          </button>
      </footer>
      <div class="modal" :class="{'is-active': showLoadingModal}">
        <div class="modal-background"></div>
        <div class="modal-content">
          <button v-if="hasLoadingError" @click="forceClose" class="delete close-button" aria-label="close"></button>
          <span v-else class="loader"></span>
          <div class="text">{{ loadingMessage }}</div>
        </div>
      </div>
    </aside>
  </div>
</template>

<script>
import Vue from 'vue'
import breakpoints from '@/libs/breakpoints'
import userAgent from '@/libs/user-agent'
import auth from '@/mixins/auth'
import componentState from '@/mixins/component-state'
import Accordion from './Accordion'

import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'

Vue.component('v-select', vSelect)
const pbOptions = [
  { value: 'most_views', label: 'Most Viewed' },
  { value: 'most_likes', label: 'Most Likes' },
  { value: 'recent_activity', label: 'Recent Activity' },
  { value: 'owner_last_name', label: 'Creator Name' },
  { value: 'most_subscribers', label: 'Most Follows' },
  { value: 'alphabetically', label: 'Project Code Ascending' },
  { value: 'alphabetically_desc', label: 'Project Code Descending' }
]

export default {
  data: function () {
    return {
      active: false,
      selectedCountries: [],
      isSigningUp: false,
      countriesChanged: false,
      redirectToHome: false,
      showLoadingModal: false,
      hasLoadingError: false,
      expandedCountries: [],
      displayingToolTip: false,
      rememberTags: true,
      filter: {},
      sort: '',
      countries: [],
      countriesSelected: [],
      awards: [],
      selectedAwards: [],
      selectedCategories: [],
      accordionIndex: 0,
      selectedCategoriesName: []
    }
  },
  beforeRouteUpdate: function (to, from, next) {
    next(vm => {
      vm.prevRoute = from
    })
  },
  props: ['isNavBar', 'isCreate', 'selectedCategoryID', 'isAwardRoute'],
  components: {
    Accordion
  },
  mixins: [componentState, auth],
  computed: {
    isIosOrAndroid: userAgent.isIOS || userAgent.isAndroid,
    isIOS: userAgent.isIOS,
    isOpenAccordion: function (index) {
      return index === this.accordionIndex
    },
    user: function () {
      return this.$store.getters.currentUser
    },
    loadingMessage: function () {
      return this.hasLoadingError ? 'Looks like something went wrong. Please close and try again' : 'Loading Countries...'
    },
    isMobile: function () {
      return breakpoints.isMobile()
    },
    showAllOption: function () {
      return !this.$isYSC && !this.$isAjas
    },
    categoriesList: function () {
      let categories = this.$store.getters.categoriesLoaded ? this.$store.getters.projectCategories : []
      if (categories.length > 0) {
        categories = categories.filter(category => !category.isPrivate)
      }
      return categories
    }
  },
  watch: {
    $route (to, from) {
      if (from.path !== '/viewAll' || from.path !== '/project') {
        localStorage.removeItem('filterData')
        this.clearAllFilters()
      }
    },
    active: function (active) {
      this.countriesChanged = false
      active ? this._callback('lockScrolling', false) : this._callback('unlockScrolling', true)
    }
  },
  mounted: function () {
    if (this.user) {
      this.getFilterOptions()
      this.rememberTags = this.$store.getters.userFilterTagsRemember.remember
    }
    if (this.$isIsef) {
      this.$store.dispatch('getAwardByEvent').then((res) => {
        this.awards = res
      })
    }
    const thisInstance = this
    this.$root.$on('clearAllFilters', function () {
      thisInstance.clearAllFilters()
    })
    const filterCall = this
    this.$root.$on('setTagFilter', function () {
      filterCall.setTagFilter()
    })
  },
  methods: {
    selectedAccordionIdx: function (index) {
      this.accordionIndex = index
    },
    getFilterData: function () {
      const allSelectedFilters = JSON.parse(localStorage.getItem('filterData'))
      if (allSelectedFilters !== null) {
        this.selectedCategories = allSelectedFilters.categories
        this.countriesSelected = allSelectedFilters.tags
        this.sort = allSelectedFilters.sortBy
        this.selectedAwards = allSelectedFilters.awards
        this.selectedCategoriesName = allSelectedFilters.categoriesTitle
      }
    },
    showModal: function (source) {
      this.active = true
      this.signupSource = source
    },
    getFiltersIfExist: function () {
      this.$store.dispatch('getFilterTags', { username: this.user.userName }).then((response) => {
        this.rememberTags = response.remember
        if (this.$store.getters.userFilterTagsRemember.remember) {
          this.selectedCountries = response.tagIDs
        }
      }, (error) => {
        this.error = error.message
      })
    },
    getFilterOptions: function () {
      this.$store.dispatch('getFilterOptions', pbOptions).then((response) => {
        if (!['', null, undefined].includes(response[0])) {
          this.filter = response[0]
          this.getFiltersIfExist()
          this.countries = response[0].filterGroups[1].tags
        } else {
          this.filter = null
        }
      }, (error) => {
        this.error = error.message
      })
    },
    setTagFilter: function () {
      const categoryNames = this.selectedCategories
      if (this.categoriesList.length > 0) {
        this.selectedCategoriesName = this.categoriesList?.filter(function (row) {
          if (categoryNames.includes(row.id)) {
            return row
          }
        })
      }

      const data = {
        username: this.isLoggedIn ? this.user.userName : '',
        tags: this.countriesSelected,
        sortBy: this.sort,
        awards: this.selectedAwards,
        categories: this.selectedCategories,
        categoriesTitle: this.selectedCategoriesName,
        remember: this.rememberTags,
        offset: 0
      }
      this.$store.dispatch('setUserFilter', data).then(() => {
        this.countriesChanged = true
        this.tagsChanged = true
        this.done()
        localStorage.setItem('filterData', JSON.stringify(data))
      }, (error) => {
        this.error = error.message
      })
      this.$root.$emit('appliedFiltersCount')
    },
    selectSortingTag: function (tag) {
      this.sort = this.sort ? '' : tag.label
    },
    clearAllFilters: function () {
      this.selectedCountries = []
      this.countriesSelected = []
      this.starredCountries = []
      this.selectedAwards = []
      this.selectedCategories = []
      this.rememberTags = false
      this.sort = ''
      if (!this.$store.getters.userFilterTagsRemember.remember) {
        this.$store.dispatch('resetUserFilter')
        localStorage.removeItem('filterData')
      }
    },
    done: function () {
      this.close()
      this.$emit('countriesChanged', this.countriesChanged)
    },
    refreshKey: function () {
      return (Math.random() + 1).toString(36).substring(7)
    },
    close: function () {
      this.active = false
      this.$emit('modalDone', true, true)
    },
    forceClose: function () {
      this.close()
    },
    dataBalloonPos: function (index) {
      let pos = 'up'
      if (index < this.countries.length / 2) {
        pos = 'down'
      }
      if (this.isMobile) {
        pos = pos + '-right'
      }
      return pos
    }
  },
  beforeMount: function () {
    this.getFilterData()
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/utils.scss';
// Close button
.close {
  font-size: 1.3rem;
  background-color: transparent;
  opacity: 0.75;
  position: absolute;
  right: 1rem;
  top: .65rem;
  border: none;
  color: white;
}
// Overriding HTML inputs
// Radio
input[type="radio"] {
  /* Add if not using autoprefixer */
  -webkit-appearance: none;
  /* Remove most all native input styles */
  appearance: none;
  /* For iOS < 15 */
  background-color: transparent;
  /* Not removed via appearance */
  margin: 0;

  font: inherit;
  color: #509DD7;
  width: 1.15em;
  height: 1.15em;
  border: 0.15em solid #509DD7;
  border-radius: 50%;
  transform: translateY(-0.075em);

  display: grid;
  place-content: center;
}

input[type="radio"]::before {
  content: "";
  width: 0.65em;
  height: 0.65em;
  border-radius: 50%;
  transform: scale(0);
  transition: 120ms transform ease-in-out;
  /* Windows High Contrast Mode */
  background-color: #509DD7;
}

input[type="radio"]:checked::before {
  transform: scale(1);
}
// Checkbox
input[type=checkbox] {
  background-color: transparent;
  appearance: none;
  width: 20px;
  height: 20px;
  border: 2px solid white;
}

input[type=checkbox]:checked {
  appearance: none;
  outline: none;
  padding: 0;
  content: none;
  border: 2px solid #509DD7;
}

input[type=checkbox]:checked::before {
  color: #509DD7;
  transition: 120ms transform ease-in-out;
  content: "\00A0\2713\00A0";
  font-weight: bolder;
  font-size: 12px;
}

// Modal Styling
.modal {
  &-card {
    background: linear-gradient(180deg, #1E1F35 0%, #39303B 100%), #FFFFFF;
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 20px;
    height: 567px;
    width: 488px;
    padding: 2rem;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    @media only screen and (max-width: 550px) {
      width: 100%;
      padding: 1rem;
      position: absolute;
      bottom: 0;
      height: 80%;
      justify-content: unset;
      border-radius: 20px 20px 0 0;
    }
  }
  &-header {
    display: flex;
    flex-direction: column;
    width: 100%;
    &-title {
      font-family: 'Helvetica Neue';
      font-style: normal;
      font-weight: 500;
      font-size: 20px;
      line-height: 24px;
      text-align: center;
      color: #FFFFFF;
      padding-bottom: 1.5rem;
      @media only screen and (max-width: 550px) {
        text-align: left;
      }
    }
  }
  &-content {
    width: 100%;
    overflow: auto;
    @media only screen and (max-width: 550px) {
      padding: 0 !important;
      margin: 0 !important;
    }
    &-countries {
      padding-top: .4rem;
      justify-content: flex-start;
      flex-wrap: wrap;
      width: 100%;
      min-height: 300px;
      &-select {
        width: 100%;
      }
    }
    &-sorting {
      display: flex;
      flex-direction: column;
      justify-content: center;
      &-item {
        color: white;
        display: flex;
        flex-direction: row;
        padding: .5rem 0;
        align-items: center;
      }
      &-title {
        font-family: 'Helvetica Neue';
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 17px;
        margin-left: .5rem;
      }
    }
  }

  // Override vue-select styles dropdown menu
  ::v-deep .modal-content-countries .vs__dropdown-menu {
    height: 100px;
    position: absolute;
    top: 2rem;
    overflow-x: hidden;
    background-color: #433F4D;
    color: #FDFDFD;
  }
  // Background colour for menu
  ::v-deep .modal-content-countries .vs__dropdown-toggle {
    background-color: #433F4D;
    color: #FDFDFD !important;
  }
  // Arrow button
  ::v-deep .modal-content-countries .vs__open-indicator {
    fill: #FDFDFD !important;
    cursor: pointer;
  }
  // Label text
  ::v-deep .modal-content-countries .vs__selected {
    color: #343B4C;
    font-family: 'cera-pro';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 14px;
  }
  // Selection Highlight
  ::v-deep .modal-content-countries .vs__dropdown-option.vs__dropdown-option--highlight {
    background-color: #555060 !important;
  }
  &-footer {
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: flex-end;
    @media only screen and (max-width: 550px) {
      position: absolute;
      bottom: 10px;
      right: 10px;
    }
  }
}

.btn {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 12px 24px;
  gap: 10px;
  width: 92px;
  height: 44px;
  border-radius: 8px;
  background-color: transparent;
  border: none;
  font-size: 1em;
  cursor: pointer;
  &-primary {
    background: #509DD7;
    color: white;
  }
  &-secondary {
    color: #509DD7;
  }
}
.accordion-header-title {
  display: block;
  width: 100%;
  position: relative;
}
span.selected-count {
  position: absolute;
  right: 10px;
}

</style>
